module.exports = __webpack_public_path__ + "static/media/Credem_Banca_CMYK.c2d8f52f.svg";